var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-dialog",
    {
      attrs: { value: _vm.value, "max-width": "700" },
      on: { input: _vm.onVisibleChange },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "device-relocation overflow-hidden",
          attrs: { "data-testid": "device-relocation-dialog" },
        },
        [
          _c("div", { staticClass: "d-flex device-relocation__panes" }, [
            _c(
              "div",
              { staticClass: "min-w-0 device-relocation__input" },
              [
                _c("p", { staticClass: "mb-2 device-relocation__title" }, [
                  _vm._v(_vm._s(_vm.$t("label.title"))),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-5 device-relocation__lead" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t("msg.lead", {
                          name: _vm.sourceName,
                          deviceId: _vm.displayDeviceId,
                        })
                      ) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "mb-2 font-weight-bold primary--text device-relocation__field-label",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("field.destination_label")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "v-radio-group",
                  {
                    staticClass: "mt-0 mb-6 device-relocation__mode",
                    attrs: {
                      row: "",
                      "hide-details": "",
                      "data-testid": "device-relocation-mode",
                    },
                    model: {
                      value: _vm.mode,
                      callback: function ($$v) {
                        _vm.mode = $$v
                      },
                      expression: "mode",
                    },
                  },
                  [
                    _c("v-radio", {
                      attrs: {
                        label: _vm.$t("field.mode_new"),
                        value: _vm.MODE_NEW,
                        color: "primary",
                        "data-testid": "device-relocation-mode-new",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-radio", {
                      attrs: {
                        label: _vm.$t("field.mode_inactive"),
                        value: _vm.MODE_INACTIVE,
                        color: "primary",
                        "data-testid": "device-relocation-mode-inactive",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isNewMode
                  ? _c("new-monitoring-point-form", {
                      key: "new-" + _vm.formKey,
                      on: { change: _vm.onNewFormChange },
                    })
                  : _c("inactive-monitoring-point-list", {
                      key: "inactive-" + _vm.formKey,
                      attrs: {
                        candidates: _vm.destinationCandidates,
                        loading: _vm.candidatesLoading,
                      },
                      on: { change: _vm.onDestinationChange },
                    }),
                _vm._v(" "),
                _c(
                  "v-card-actions",
                  { staticClass: "px-0" },
                  [
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "dialog-action",
                      {
                        attrs: { "data-testid": "device-relocation-cancel" },
                        on: { click: _vm.cancel },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.cancel")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "dialog-action",
                      {
                        attrs: {
                          loading: _vm.loading,
                          disabled: !_vm.canSubmit || _vm.loading,
                          "data-testid": "device-relocation-submit",
                        },
                        on: { click: _vm.submit },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.submit")) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "device-relocation__notice",
                attrs: { "data-testid": "device-relocation-notice" },
              },
              [
                _c(
                  "v-alert",
                  {
                    staticClass: "device-relocation__warning",
                    attrs: {
                      dense: "",
                      text: "",
                      type: "warning",
                      icon: false,
                    },
                  },
                  [
                    _c("p", { staticClass: "font-weight-bold mb-1" }, [
                      _vm._v(_vm._s(_vm.$t("msg.notice_head"))),
                    ]),
                    _vm._v(" "),
                    _c("ol", { staticClass: "ma-0 pl-5" }, [
                      _c("li", [
                        _vm._v(_vm._s(_vm.$t("msg.notice_step_stop"))),
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(_vm._s(_vm.$t("msg.notice_step_format"))),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "text-caption font-weight-bold mb-1 device-relocation__after-head",
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("msg.after_head")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "ma-0 device-relocation__after-list" },
                  [
                    _c("li", [_vm._v(_vm._s(_vm.$t("msg.after_keep_device")))]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("msg.after_source_inactive"))),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _vm._v(_vm._s(_vm.$t("msg.after_data_destination"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }